import type { MapContainerStyle } from './types';

export const MAP_CONTAINER_STYLE: MapContainerStyle = {
  height: '400px',
  width: '100%',
  borderRadius: '20px',
};

export const AUTOCOMPLETE_FIELDS = [
  'address_components',
  'geometry',
  'name',
  'formatted_address',
] as const;

export const PALETTE_DROP_PADDING_PX = 8;
export const MARKER_MOUNT_DELAY_MS = 100;
export const PLACED_MARKER_ZOOM = 17;
export const DEFAULT_MAP_ZOOM = 12;
/** Closer initial zoom for entity maps (stage, attraction, festival vendor) before a pin is placed. */
export const ENTITY_MAP_DEFAULT_ZOOM = 15;
